module.exports = __webpack_public_path__ + "media/src/images/icons/ascending-d212bbef619b9f17dc4afa33220ce973.svg";